import React from "react";

import { NorthbeamUtmPlatform } from "@features/utm-guide";

import { CopyUtmParams } from "../copy-utm-params";

export const Google = () => (
  <div className="flex flex-col gap-3">
    <p className="mb-0">
      You will only need to set your UTM tracking parameters in the{" "}
      <b>Final URL Suffix</b> at the <b>Account level</b> for Google Ads. Please
      follow the instructions in the video below to do so:
    </p>
    <CopyUtmParams
      className="mb-3"
      platform={NorthbeamUtmPlatform.GOOGLE}
      hideQuestionMark
    />
    <p className="mb-0">
      In the video below, you`ll see our parameters are placed at the account
      level. If you have any existing parameters at a lower level (ex. campaign,
      ad group, or ad), those will take priority over the account level.
    </p>
    <p className="mb-0">As a solution, please do one of the following:</p>
    <ul className="list-disc pl-4 mb-0">
      <li>Move our parameters down to the lower level.</li>
      <li>Move existing parameters up to the account level.</li>
    </ul>
    <iframe
      src="https://www.loom.com/embed/62739ccc2bfe4989a8e0a4b14ffca5b8"
      title="Google ad UTM tracking description"
      width="100%"
      height="500"
      frameBorder="0"
      className="mt-2"
    />
  </div>
);
